export default __webpack_public_path__ + "static/media/failed_mail.ec8c255b.svg";